import React from 'react';
import { Button, Flex } from '@chakra-ui/react';

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const pageNumbers = [];

  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }

  return (
    <Flex mt={4} justifyContent="center" alignItems="center">
      {currentPage > 1 && (
        <Button
          onClick={() => onPageChange(currentPage - 1)}
          mr={2}
          size="sm"
        >
          Previous
        </Button>
      )}
      {pageNumbers.map((number) => (
        <Button
          key={number}
          onClick={() => onPageChange(number)}
          mr={2}
          size="sm"
          colorScheme={number === currentPage ? 'blue' : 'gray'}
        >
          {number}
        </Button>
      ))}
      {currentPage < totalPages && (
        <Button
          onClick={() => onPageChange(currentPage + 1)}
          ml={2}
          size="sm"
        >
          Next
        </Button>
      )}
    </Flex>
  );
};

export default Pagination;
